import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'
import type {
  FolderVisibility,
  WorkspaceItem,
} from '@store/reducers/dashboard/types'
import { useDispatch } from 'react-redux'

export const useAccessUpdate = (
  folder: WorkspaceItem | null,
  workspaceId?: ID
) => {
  const dispatch = useDispatch()

  const onPublic = (next: boolean) => {
    if (!folder || !workspaceId) {
      return
    }

    const visibility: FolderVisibility = next ? 'public' : 'restricted'
    dispatch(
      DashboardActions.folders.updateVisibility({
        id: folder.id,
        workspaceId,
        visibility,
      })
    )
  }

  const onToggle = (id: ID) => {
    if (!folder || !workspaceId) {
      return
    }

    dispatch(
      DashboardActions.folders.updateMemberAccess({
        id,
        workspaceId,
        folderId: folder.id,
      })
    )
  }

  return { onPublic, onToggle }
}
